import {Navigate, Route, Routes, Outlet} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
// import {CreateContactenos} from './Components/CreateContactenos'
// import {ViewContactenos} from './Components/ViewContactenos'
import {useIntl} from 'react-intl'
import { ViewReclamaciones } from './Components/ViewReclamaciones'
import { CreateReclamaciones } from './Components/CreateReclamaciones'

const carsBreadCrumbs: Array<PageLink> = [
  {
    title: 'Menú Libro de Reclamaciones',
    path: '/menu/administracion/reclamaciones',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ContactenosPage = () => {
  const intl = useIntl()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='create'
          element={
            <>
              <PageTitle breadcrumbs={carsBreadCrumbs}>
                {intl.formatMessage({id: 'CONTACTUS_MENU'})}
              </PageTitle>
              <CreateReclamaciones />
            </>
          }
        />

        <Route
          path='view'
          element={
            <>
              <PageTitle breadcrumbs={carsBreadCrumbs}>
                {intl.formatMessage({id: 'CLAIMS_MENU'})}
              </PageTitle>
              <ViewReclamaciones />
            </>
          }
        />

        <Route index element={<Navigate to='/menu/administracion/reclamaciones' />} />
      </Route>
    </Routes>
  )
}

export default ContactenosPage
